// extracted by mini-css-extract-plugin
export default {"todayRow":"ZqGwEWv15SPs7xklYtC7","score":"Oxl3k8eVD_zIrbKyvBiG"};